/**
 * Vymid quick-buy fix.
 *
 * Replaces fragile cart-permalink navigation (<a href="/cart/{variant}:{qty}">)
 * with a real AJAX Cart API call (POST /cart/add.js), then a hard navigation
 * to /checkout. This avoids the empty-cart / redirect-to-homepage bug caused
 * by the theme's client-side view-transition navigation intercepting a plain
 * permalink link, and gives a proper loading/disabled state so a double
 * click cannot add the item twice.
 *
 * Matches ANY link on the site whose href looks like /cart/<variant id>:<qty>,
 * so it also protects any future button built the same fragile way.
 */
(function () {
  var CART_LINK_RE = /^\/cart\/(\d+):(\d+)(?:[?#].*)?$/;
  var BUSY_ATTR = 'data-vymid-busy';

  function findCartLink(el) {
    while (el && el !== document.body) {
      if (el.tagName === 'A' && el.getAttribute('href') && CART_LINK_RE.test(el.getAttribute('href'))) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function setLoading(link, loading) {
    if (loading) {
      link.setAttribute(BUSY_ATTR, 'true');
      link.setAttribute('aria-busy', 'true');
      link.setAttribute('aria-disabled', 'true');
      link.classList.add('vymid-cta--loading');
      if (!link.dataset.vymidOriginalText) {
        link.dataset.vymidOriginalText = link.textContent;
      }
      link.textContent = link.dir === 'rtl' || /[؀-ۿ]/.test(link.textContent)
        ? '...جارٍ التحميل'
        : 'Chargement...';
    } else {
      link.removeAttribute(BUSY_ATTR);
      link.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
      link.classList.remove('vymid-cta--loading');
      if (link.dataset.vymidOriginalText) {
        link.textContent = link.dataset.vymidOriginalText;
      }
    }
  }

  function showError(link) {
    var next = link.nextElementSibling;
    var msg;
    if (next && next.classList && next.classList.contains('vymid-cta-error')) {
      msg = next;
    } else {
      msg = document.createElement('div');
      msg.className = 'vymid-cta-error';
      msg.setAttribute('role', 'alert');
      msg.style.cssText = 'color:#b3261e;font-size:0.85rem;margin-top:8px;';
      link.insertAdjacentElement('afterend', msg);
    }
    msg.innerHTML =
      '<span dir="rtl">حدث خطأ أثناء إضافة المنتج. حاول مرة أخرى.</span><br>' +
      '<span>Une erreur est survenue, merci de réessayer.</span>';
  }

  document.addEventListener('click', function (event) {
    var link = findCartLink(event.target);
    if (!link) return;
    if (link.getAttribute(BUSY_ATTR) === 'true') {
      event.preventDefault();
      return;
    }

    var match = link.getAttribute('href').match(CART_LINK_RE);
    if (!match) return;

    event.preventDefault();

    var variantId = match[1];
    var quantity = parseInt(match[2], 10) || 1;

    setLoading(link, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity }],
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error((data && data.description) || 'add_to_cart_failed');
          });
        }
        return response.json();
      })
      .then(function () {
        // Real order flow: send the customer straight to Shopify's own
        // checkout (hard navigation, not a client-side route) so COD
        // payment selection and address collection happen there.
        window.location.assign('/checkout');
      })
      .catch(function (err) {
        console.error('[vymid-quick-buy] add to cart failed:', err);
        setLoading(link, false);
        showError(link);
      });
  });
})();
